import { render, staticRenderFns } from "./PerseoLayout.vue?vue&type=template&id=4b29f4f8&scoped=true"
import script from "./PerseoLayout.vue?vue&type=script&lang=js"
export * from "./PerseoLayout.vue?vue&type=script&lang=js"
import style0 from "./PerseoLayout.vue?vue&type=style&index=0&id=4b29f4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29f4f8",
  null
  
)

export default component.exports